<template>
  <div class="col-md-12 bank_payment_imports">
    <div class="response_table">
      <div class="spinner" v-if="loading"><scale-loader /></div>
      <p v-else-if="!import_history.length">{{ translate('no_data') }}</p>
      <table v-else>
        <thead>
          <tr>
            <th v-for="column in columns" :key="column" scope="col">
              {{ translate('bank_payment.import_history.' + column) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, key) in import_history" :key="key">
            <td
                v-for="column in columns"
                :key="column"
                :data-label="translate('bank_payment.import_history.' + column)"
                :class="{ 'text-left': column === 'file_name' || column === 'error_message' }"
            >
              {{ column === 'ts_create' ? get_date(item[column]) : item[column] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankPaymentImports',
  data () {
    return {
      import_history: [],
      loading: true,
      columns: ['file_name', 'file_size', 'user_name', 'status', 'error_message', 'parsed', 'created', 'skipped_duplicates', 'skipped_invalid', 'ts_create']
    }
  },
  created () {
    this.get_import_history()
  },
  methods: {
    get_import_history() {
      this.loading = true
      this.$http.v1.getBankPaymentImportHistory((response) => {
        this.import_history = response.data.data ?? response.data
        this.loading = false
      }, () => {
        this.loading = false
        this.global_notify('danger', this.translate('bank_payment.import_history.load_error'))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bank_payment_imports{
  height: 100%;
  display: flex;
  flex-direction: column;
  .response_table{
    padding-left: 0;
    padding-right: 0;
    th, td{
      font-size: 12px;
      overflow-wrap: anywhere;
    }
    .text-left{
      text-align: left;
    }
  }
}
</style>
